import { useEffect, useState } from 'react'
import { InitialSeries } from '../../../../types'
import { SearchCondition } from './SearchCondition'
import { CheckBox } from './Checkbox'
import { OpeningCondition } from '../SearchConditionList'

type Props = {
  selectedInitialSeries: string
  setSelectedInitialSeries: React.Dispatch<React.SetStateAction<string>>
  opening: boolean
  setOpeningCondition: React.Dispatch<React.SetStateAction<OpeningCondition>>
}

export const InitialSeriesSelector: React.FC<Props> = (props) => {
  const [initialSeries, setInitialSeries] = useState<InitialSeries[]>(
    props.selectedInitialSeries.split(',') as InitialSeries[]
  )

  useEffect(() => {
    props.setSelectedInitialSeries(initialSeries.join(','))
  }, [initialSeries])

  const handleInitialSeriesChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const key = e.target.value as InitialSeries
    if (initialSeries.includes(key)) {
      setInitialSeries(initialSeries.filter((s) => s !== key))
    } else {
      setInitialSeries([...initialSeries, key])
    }
  }

  return (
    <SearchCondition
      title="スピーダ調達シリーズ"
      selected={!!props.selectedInitialSeries}
      opening={props.opening}
      toggleOpen={() => {
        if (props.opening) {
          props.setOpeningCondition(null)
        } else {
          props.setOpeningCondition('InitialSeries')
        }
      }}
      className={'filterInitialSeries'}
    >
      <InitialSeriesCheckBox
        value={'Seed'}
        handler={handleInitialSeriesChange}
        checked={initialSeries.includes('Seed')}
      >
        シード
      </InitialSeriesCheckBox>
      <InitialSeriesCheckBox
        value={'Series A'}
        handler={handleInitialSeriesChange}
        checked={initialSeries.includes('Series A')}
      >
        シリーズA
      </InitialSeriesCheckBox>
      <InitialSeriesCheckBox
        value={'Series B'}
        handler={handleInitialSeriesChange}
        checked={initialSeries.includes('Series B')}
      >
        シリーズB
      </InitialSeriesCheckBox>
      <InitialSeriesCheckBox
        value={'Series C'}
        handler={handleInitialSeriesChange}
        checked={initialSeries.includes('Series C')}
      >
        シリーズC
      </InitialSeriesCheckBox>
      <InitialSeriesCheckBox
        value={'Series D'}
        handler={handleInitialSeriesChange}
        checked={initialSeries.includes('Series D')}
      >
        シリーズD
      </InitialSeriesCheckBox>
      <InitialSeriesCheckBox
        value={'Series E'}
        handler={handleInitialSeriesChange}
        checked={initialSeries.includes('Series E')}
      >
        シリーズE
      </InitialSeriesCheckBox>
      <InitialSeriesCheckBox
        value={'Series F'}
        handler={handleInitialSeriesChange}
        checked={initialSeries.includes('Series F')}
      >
        シリーズF
      </InitialSeriesCheckBox>
      <InitialSeriesCheckBox
        value={'Series G'}
        handler={handleInitialSeriesChange}
        checked={initialSeries.includes('Series G')}
      >
        シリーズG
      </InitialSeriesCheckBox>
    </SearchCondition>
  )
}

type InitialSeriesCheckBoxProps = {
  value: InitialSeries
  checked: boolean
  children: React.ReactNode
  handler: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const InitialSeriesCheckBox: React.FC<InitialSeriesCheckBoxProps> = (props) => {
  return (
    <CheckBox
      name="initial_series"
      value={props.value}
      handler={props.handler}
      checked={props.checked}
    >
      {props.children}
    </CheckBox>
  )
}
